document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('map-modal');
  
  // Exit early if modal doesn't exist
  if (!modal) {
      return;
  }
  
  const modalBg = document.getElementById('modal-bg');
  const closeButton = document.querySelector('.close-modal');
  const body = document.body;

  // Function to open modal
  function openModal() {
      // Remove hidden class and add modal-open to body
      modal.classList.remove('hidden');
      body.classList.add('modal-open');
      
      // Add modal-animate class after 3ms
      setTimeout(() => {
          body.classList.add('modal-animate');
      }, 3);
  }

  // Function to close modal
  function closeModal() {
      // Remove modal-animate class first
      body.classList.remove('modal-animate');
      
      // Wait for any potential transition, then remove modal-open and hide modal
      setTimeout(() => {
          body.classList.remove('modal-open');
          modal.classList.add('hidden');
      }, 300); // Adjust timing based on your CSS transitions
  }

  // Add event listeners to all elements with class "launch-map-modal"
  const launchButtons = document.querySelectorAll('.launch-map-modal');
  launchButtons.forEach(button => {
      button.addEventListener('click', function(e) {
          e.preventDefault();
          openModal();
      });
  });

  // Close modal when close button is clicked
  if (closeButton) {
      closeButton.addEventListener('click', function(e) {
          e.preventDefault();
          closeModal();
      });
  }

  // Close modal when modal background is clicked
  if (modalBg) {
      modalBg.addEventListener('click', function(e) {
          // Only close if the click is directly on the background, not on child elements
          if (e.target === modalBg) {
              closeModal();
          }
      });
  }

  // Optional: Close modal with Escape key
  document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
          closeModal();
      }
  });
});